import { createContext, FC, PropsWithChildren } from "react";
import { useLegalOrgsForm } from "../hooks/useLegalOrgsForm";
import type { ILegalOrgsFormState } from "../types/legal-orgs-form";

const defaultState: ILegalOrgsFormState = {
    bisGroups: [],
    bisUnits: [],
    countries: [],
    orgs: [],
    loading: true,
    error: null,
    extUserId: null,
    reloadOrgs: async () => {},
};

export const legalOrgsFormContext = createContext<ILegalOrgsFormState>(defaultState);

interface ILegalOrgsFormProviderProps extends PropsWithChildren {
    extUserId?: string | null;
}

export const LegalOrgsFormProvider: FC<ILegalOrgsFormProviderProps> = ({ children, extUserId = null }) => {
    const value = useLegalOrgsForm(extUserId ?? null);

    return (
        <legalOrgsFormContext.Provider value={value}>
            {children}
        </legalOrgsFormContext.Provider>
    );
};
